import { Component, OnInit, AfterViewChecked, OnDestroy, DoCheck } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { RightSideDrawerService } from '../right-side-drawer.service';
import usStateLocations from '../../../../assets/us-state-locations.json';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from '../../session-service/session.service';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { Messages } from '../../../shared/constants/messages';
import { debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { role } from '../../../shared/constants/role-enum';
import { SESSION_CONST } from '../../constants/session-constants';
import { AdminClientUsersService } from 'src/app/admin/admin-client-users/admin-client-users.service';
import { UserDetails } from 'src/app/core/models/user-details.model';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { APP_CONSTANTS } from '../../constants/app-constants';
import { DOMAIN_WHITELIST } from '../../constants/app-constants';
import { ROUTE_URL } from '../../constants/route-constants';

@Component({
  selector: 'add-user-form',
  templateUrl: './add-user-component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent
  implements OnInit, AfterViewChecked, OnDestroy, DoCheck {
  isFromCreateStudy: boolean = false;
  isFromEditStudy: boolean = false;
  targetForm: FormGroup; // name of formGroup in template
  targetFormSubmitted: boolean = false;
  currentDate: Date = new Date();
  hireDateRequired: boolean = false;
  //isInsert: boolean = true;
  subscription: Subscription;
  employmentDatesError: boolean = false;
  isClient: boolean = false;
  noResults: boolean;
  clients: any = [];
  engagementClient: string = '';
  isClientSelected: boolean = false;
  emailPattern = /[a-zA-Z0-9_.+-,;]+@(?:(?:[a-zA-Z0-9-]+\.,;)?[a-zA-Z]+\.,;)?(kpmg|KPMG|Kpmg|kPmg|kpMg|kpmG|KPmg|KpMg|KpmG|kPMg|kPmG|kpMG|KPMg|kPMG|KPmG|KpMG)/;
  isContractor: boolean = false;
  Email: string;
  IsEmailExists: boolean = false;
  IsSignInNameExists: boolean = false;
  IsWhitelistDomain: boolean = false;
  userRoles: Array<number> = [];
  championRole: number = role.champion;
  adminRole: number = role.admin;
  enableSignIn: boolean = false;
  IsRoleEnabled: boolean = false;
  isDisplaynameEntered: boolean = false;
  public states = usStateLocations.map(function (item) {
    return item.abbreviation;
  });
  isClientMode: boolean = false;
  clientName: string;
  targetFormSubmitCount: number = 0;
  firstName: string = '';
  lastName: string = '';
  user: UserDetails;
  hasAdminAccess = false;
  isClientAdmin = false;
  addClientText: string = '';
  isFromManageClientUserDrawer: boolean = false;

  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    public _clientUsersService: AdminClientUsersService,
    private formBuilder: FormBuilder,
    public sessionService: SessionService,
    public _toastrService: ToastrService,
    public _router: Router,
    private _loader: LoadingIndicatorService,
    private _userDataService: UserDataService
  ) { }

  ngOnInit() {
    this._loader.display(true, true);
    this.isFromCreateStudy = this.rightSideDrawerService.isFromCreateStudy;
    this.isFromEditStudy = this.rightSideDrawerService.isFromEditStudy;
    this.isClientMode = this.sessionService.getSession(SESSION_CONST.ISCLIENTMODE) === 'true';
    this.clientName = this.rightSideDrawerService?.singleRowAddData
      ? this.rightSideDrawerService.singleRowAddData.trim()
      : null;

    this.isFromManageClientUserDrawer = this.rightSideDrawerService?.manageClientUserData ?
      this.rightSideDrawerService.manageClientUserData.isManageClientUser : false;

    this._userDataService.userDetails$.subscribe(userDetails => {
      this.user = userDetails;
      this.hasAdminAccess = (this.user.roleId === role.admin) || (this.user.roleId === role.champion) ? true : false;
      this.isClientAdmin = this.user.roleId === role.clientAdmin ? true : false;
      this.addClientText = this.isClientAdmin ? APP_CONSTANTS.ADD_CLIENTADMIN_USER : APP_CONSTANTS.ADD_CLIENT;
      if (this.user && this.user.roleId === role.clientAdmin) {
        this.getclientUsersforAdmin();
      }
    });

    if (!this.isClientAdmin) {
      this._clientUsersService.GetClients().subscribe((data: any) => {
        this.clients = data.result;
      });
    }
    this.isClient = this._clientUsersService.isClient;
    this.ResetFormData();
    this._loader.display(false);
    if (this.isFromManageClientUserDrawer) {
      this.clientName = this.rightSideDrawerService.manageClientUserData.clientName;
    }

  }

  getclientUsersforAdmin() {
    this._clientUsersService.getClientusersforAdmin().subscribe((data: any) => {
      if (data.success) {
        this.clientName = data?.result?.clientName;
      }
    });
  }

  ngDoCheck() {
    let value =
      this.targetForm.controls.signinname.value ||
      this.targetForm.controls.email.value ||
      this.targetForm.controls.displayName.value ||
      this.targetForm.controls.clientName.value;

    if (value) {
      if (this.isClient) {
        this.rightSideDrawerService.setMandatoryField(true, 'Add Client User');
      } else {
        this.rightSideDrawerService.setMandatoryField(true, 'Add KPMG User');
      }
    } else {
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
  }

  SetRoles(roleId: any) {
    this.IsRoleEnabled = true;
    if (this.userRoles.filter(x => x === roleId).length === 0) {
      this.userRoles.push(roleId);
    } else {
      this.userRoles = this.userRoles.filter(x => x !== roleId);
    }
  }
  // reset and create the form group on start up.
  ResetFormData() {
    this.targetForm = this.formBuilder.group({
      userId: [''],
      signinname: [
        '',
        [
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
          ),
        ],
      ],
      clientName: ['', this.isClient && !this.isClientAdmin ? Validators.required : null],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
          ),
        ],
      ],
      displayName: ['', Validators.required],
      firstName: [''],
      lastName: [''],
      IsContractor: ['', this.isContractor ? Validators.required : false],
    });
    // setTimeout(() => {
    //   this.subscription = this._clientUsersService.isInsert.subscribe(x => {
    //     if (x === true) {
    //       this.isInsert = true;
    //     } else {
    //       this.isInsert = false;
    //       let userData = this._clientUsersService.selectedUserDetails;
    //       this.targetForm.patchValue({
    //         userId: userData.userId,
    //         name: userData.userName,
    //         clientName: userData.clientName,
    //         IsContractor: this.isContractor,
    //         email: userData.email,
    //       });
    //     }
    //   });
    // });
  }

  IsContractor() {
    this.isContractor = !this.isContractor;
  }

  trimSpecialChar(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/ ]/g, ''),
    );
  }
  trimSpecialCharName(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-,'.()_/@ ]/g, ''),
    );
  }

  get f() {
    return this.targetForm?.controls;
  }

  checkSigninName(ctrl: any) {
    let emailFormValue = this.targetForm.get(ctrl).value.trim();
    if (!this.targetForm.get(ctrl).hasError('pattern') && emailFormValue && emailFormValue.trim().length > 0) {
      this._clientUsersService.CheckSignInName(emailFormValue).subscribe((data: any) => {
        if (data && data.result != null) {
          ctrl === 'email' ? this.IsEmailExists = data.result : this.IsSignInNameExists = data.result;

          //Check if the email domain is part of the Domain_Whitelis in app-constants (Only for the Add KPMG user form)
          if (!this.isClient) {
            if (emailFormValue.split("@").length > 1) {
              let fullDomain = emailFormValue.split("@")[1];
              let domainFound = DOMAIN_WHITELIST.find(element => element == fullDomain.toLowerCase())

              if (!domainFound) {
                domainFound = fullDomain.toLowerCase().includes("kpmg");
            }
              // ELSE: Then the whitelist domain was not found and the email is NOT valid
              this.IsWhitelistDomain = !!domainFound;
            } else {
                this.IsWhitelistDomain = false;
            }
            // If True: then the whitelist domain was found and the email is valid

          } else {
            this.IsWhitelistDomain = true; //If isClient=true we should not check Whitelisted Domains
          }

        }
      });
    } else {
      this.IsSignInNameExists = this.IsSignInNameExists;
      this.IsEmailExists = this.IsEmailExists;
    }
  }


  // Delete empty properties to clean form data to send to back-end API
  // Blank values sent to the back-end API gives errors.
  cleanTargetFormToPost = () => {
    let formData = this.sessionService.removeNullEmptyValues(
      this.targetForm.value,
    );

    if (this.isClientSelected) {
      formData.clientName = formData.clientName.clientName;
    }
    if (this.isClientAdmin) {
      formData.clientName = this.clientName;
    }
    let emailsplit = formData.email.split('@');
    formData.email = emailsplit[0] + '@' + emailsplit[1].toLowerCase();

    formData.IsContractor = this.isContractor;
    formData.roleIds =
      this.userRoles.length > 0 ? this.userRoles.join(',') : '';
    return formData;
  };

  // This function runs when "Add user" button is clicked
  postRightSideDrawerData = () => {
    this.targetFormSubmitCount = ++this.targetFormSubmitCount;
    if (this.targetFormSubmitCount === 1) {
      const formData = this.cleanTargetFormToPost()
      this._loader.display(true, true);
      this._clientUsersService.CreateUser(formData).subscribe(data => {
        // Refresh data table on page
        if (data.success) {
          this.targetFormSubmitCount = 0;
          if (this.isClient) {
            this.rightSideDrawerService.closeRightSideDrawer(Messages.Admin.ClientUser.AddClientUserSuccess);
          } else {
            this.rightSideDrawerService.closeRightSideDrawer();
          }
          if (this._router.url === ROUTE_URL.ADMIN_USER || this._router.url === ROUTE_URL.ADMIN_CLIENT_USER) {
            this._clientUsersService.refreshTable();
            this._toastrService.setSuccessMessage(this.isClient ? Messages.Admin.ClientUser.AddClientUserSuccess : Messages.Admin.User.AddUserSuccess);
          } else if (this._router.url === ROUTE_URL.HOME1) {
            if (this.isFromCreateStudy) {
              this._toastrService.setSuccessMessage(this.isClient ? Messages.Admin.ClientUser.AddClientUserSuccess : Messages.Admin.User.AddUserSuccess);
            } else if (this.isFromEditStudy || this.isFromManageClientUserDrawer) {
              this._toastrService.setSuccessMessage(this.isClient ? Messages.Admin.ClientUser.AddClientUserSuccess : Messages.Admin.User.AddUserSuccess);
            }
          }
          else {
            this._toastrService.setSuccessMessage(Messages.Admin.ClientUser.AddClientUserSuccess);
          }
        } else {
          if (this._router.url === ROUTE_URL.ADMIN_USER) {
            this._toastrService.setErrorMessage(Messages.Admin.User.AddUserFailure)
          } else {
            this._toastrService.setErrorMessage(Messages.Admin.ClientUser.AddClientUserFailure);
          }
        }
        this._loader.display(false);
        this.targetFormSubmitCount = 0;
      });
    }

    // Change variable to note a form submission attempt was made.
    this.targetFormSubmitted = true;
  };

  public resetRightSideDrawerData = () => {
    //this.targetForm.reset();
    this.targetFormSubmitted = false;
  };

  ngAfterViewChecked() {
    // Refresh form inputs if drawer is opened or loaded.
    if (this.rightSideDrawerService.triggerRightSideDrawerClick) {
      this.rightSideDrawerService.triggerRightSideDrawerClick = false; // Set trigger to false so that this action is only performed once. Without this, the form would keep resetting on every change on any input.
      this.resetRightSideDrawerData();
      if (this.isClientMode) {
        this.clientName =
          this.rightSideDrawerService &&
            this.rightSideDrawerService.singleRowAddData &&
            this.rightSideDrawerService.singleRowAddData
            ? this.rightSideDrawerService.singleRowAddData.trim()
            : null;
      }
    }
  }

  chkclientName() {
    return this.clientName.trim() !== '';
  }

  ngOnDestroy(): void {
    //this.subscription.unsubscribe();
    if (this.isFromCreateStudy) {
      this.isFromCreateStudy = false;
      this.rightSideDrawerService.setIsFromCreateStudy(false);
    } else if (this.isFromEditStudy || this.isFromManageClientUserDrawer) {
      this.isFromEditStudy = false;
      this.rightSideDrawerService.setIsFromEditStudy(false);
    }
  }

  searchExistingClients = (searchPhrase$: Observable<any>) =>
    searchPhrase$.pipe(
      debounceTime(150), // Wait 150 milliseconds for typing to stop
      distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
      tap(term => {
        // Remove "no results" message in case it was displayed from the previous search
        this.noResults = false;
      }),
      switchMap(term => {
        if (term !== '') {
          // Process the search term entered
          return this.searchClients(term).pipe(
            switchMap(data => {
              this.engagementClient = term as string;
              return of(data);
            }),
            catchError(() => {
              this.noResults = true;
              return of([]);
            }),
          );
        } else {
          return of([]);
        }
      }),
    );

  // Filter clients autosuggest
  private searchClients(term: any): Observable<any> {
    if (this.clients) {
      return of(
        this.clients.filter((item: any) =>
          item.clientName.toLowerCase().includes(term.toLowerCase()),
        ),
      );
    } else {
      return of([]);
    }
  }

  displayNameConcat(event: any, formControlName: string) {
    formControlName === 'firstName' ? this.firstName = event.target.value : this.lastName = event.target.value;
    let displayNamevalue = (this.firstName ? this.firstName.trim() : '') + ' ' + (this.lastName ? this.lastName.trim() : '');

    // Display name validation.
    this.targetForm.controls['displayName'].setValue(displayNamevalue.trim().length > 0 ? displayNamevalue.trim() : '');
    this.isDisplaynameEntered = displayNamevalue.trim().length > 0;
  }

  inputClient() {
    let clientName = this.targetForm.get('clientName').value;
    if (clientName && clientName.trim().length > 0) {
      this.isClientSelected = true;
    } else {
      this.isClientSelected = false;
      this.sessionService.setSession(SESSION_CONST.CLIENTNAME, '');
    }
  }
  displaynameInput() {
    let displayname = this.targetForm.get('displayName').value;
    if (displayname && displayname.trim().length > 0) {
      this.isDisplaynameEntered = true;
    } else {
      this.isDisplaynameEntered = false;
    }
  }

  onClientSelected($event: any) {
    this.engagementClient = $event.item.clientName;
    this.isClientSelected = true;
    this.sessionService.setSession(
      SESSION_CONST.CLIENTNAME,
      this.engagementClient ? this.engagementClient : '',
    );
  }

  enableSigninName(event: any) {
    const getSignInNameValidation = this.targetForm.get('signinname');
    console.log(event.target.value)
    if (event.target.checked) {
      this.enableSignIn = true;
      getSignInNameValidation.clearValidators();
      getSignInNameValidation.enable();
      getSignInNameValidation.setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]);
      getSignInNameValidation.updateValueAndValidity();
      getSignInNameValidation.setValue(null);
    }
    else {
      this.enableSignIn = false;
      getSignInNameValidation.clearValidators();
      getSignInNameValidation.updateValueAndValidity();
      getSignInNameValidation.setValue(null);
      this.IsSignInNameExists = false;
    }

  }

  // format for clients search
  clientFormatter = (result: any) =>
    typeof result.clientName === 'undefined' ? result : result.clientName;
}
